import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './reset.css';
import App from './App';
import webtexts from './assets/webtexts.json'
import {Helmet} from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root'));
const titles = [
  { path:'/', title: 'Home', description: webtexts.metaTags.home.description, keywords: webtexts.metaTags.home.keywords},
  { path:'/projects', title:'Projects', description: webtexts.metaTags.projects.description, keywords: webtexts.metaTags.projects.keywords},
  { path:'/about', title:'About Us', description: webtexts.metaTags.about.description, keywords: webtexts.metaTags.about.keywords},
  { path:'/team', title:'Our Team', description: webtexts.metaTags.team.description, keywords: webtexts.metaTags.team.keywords},
  { path:'/contact', title:'Contact Us', description: webtexts.metaTags.contact.description, keywords: webtexts.metaTags.contact.keywords},
]


const currentPath = window.location.pathname;
const matchedTitle = titles.find(title => title.path === currentPath)

let description = webtexts.metaTags.default.description;
let keywords = webtexts.metaTags.default.keywords;


if(matchedTitle) {
  document.title = `${matchedTitle.title} | Pangu Enterprises Inc. `;
  description = matchedTitle.description;
  keywords = matchedTitle.keywords;
} else {
  document.title = 'Pangu Enterprises Incorporated';
}

root.render(
  <React.StrictMode>
    <Helmet>
      <meta name='description' content={description}/>
      <meta name='keywords' content={keywords}/>
    </Helmet>

    <App />
  </React.StrictMode>
);